import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=3f8ef114&"
import script from "./InputText.vue?vue&type=script&lang=js&"
export * from "./InputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8ef114')) {
      api.createRecord('3f8ef114', component.options)
    } else {
      api.reload('3f8ef114', component.options)
    }
    module.hot.accept("./InputText.vue?vue&type=template&id=3f8ef114&", function () {
      api.rerender('3f8ef114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputText/InputText.vue"
export default component.exports